import { render, staticRenderFns } from "./AppUsers.vue?vue&type=template&id=c9873870&scoped=true&lang=pug&"
import script from "./AppUsers.vue?vue&type=script&lang=ts&"
export * from "./AppUsers.vue?vue&type=script&lang=ts&"
import style0 from "./AppUsers.vue?vue&type=style&index=0&id=c9873870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9873870",
  null
  
)

export default component.exports